// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.rentercontact.RentalManagerRenterContactWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  ListingAlias,
  RentalManagerRenterContactGetLikelyTenantsRequestDto,
  RentalManagerRenterContactGetLikelyTenantsResponseDto,
  RentalManagerRenterContactGetTenanciesRequestDto,
  RentalManagerRenterContactGetTenanciesResponseDto,
  RentalManagerRenterContactGetTenantsRequestDto,
  RentalManagerRenterContactGetTenantsResponseDto,
} from '../..';

interface GetTenantsRequestedToUsePaymentParams {
  listingAlias: ListingAlias;
}

export const RentalManagerRenterContactWebApiHandler_getLikelyTenants_Path =
  '/api/web/v1/users/renterContact/getLikelyTenants';

/**
 * Get likely tenants, sorted by probability of being a current tenant
 */
export const RentalManagerRenterContactWebApiHandler_getLikelyTenants = (
  postData: RentalManagerRenterContactGetLikelyTenantsRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    never,
    RentalManagerRenterContactGetLikelyTenantsRequestDto,
    RentalManagerRenterContactGetLikelyTenantsResponseDto
  >({
    endpoint: RentalManagerRenterContactWebApiHandler_getLikelyTenants_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerRenterContactWebApiHandler_getTenancies_Path = '/api/web/v1/users/renterContact/getTenancies';

/**
 * Get tenancies, sorted by earliest tenancy start date, then tenant last name
 */
export const RentalManagerRenterContactWebApiHandler_getTenancies = (
  postData: RentalManagerRenterContactGetTenanciesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    never,
    RentalManagerRenterContactGetTenanciesRequestDto,
    RentalManagerRenterContactGetTenanciesResponseDto
  >({
    endpoint: RentalManagerRenterContactWebApiHandler_getTenancies_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerRenterContactWebApiHandler_getTenants_Path = '/api/web/v1/users/renterContact/getTenants';

/**
 * Get tenants grouped by tenant with their tenancies
 */
export const RentalManagerRenterContactWebApiHandler_getTenants = (
  postData: RentalManagerRenterContactGetTenantsRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    never,
    RentalManagerRenterContactGetTenantsRequestDto,
    RentalManagerRenterContactGetTenantsResponseDto
  >({
    endpoint: RentalManagerRenterContactWebApiHandler_getTenants_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerRenterContactWebApiHandler_getTenantsRequestedToUsePayment_Path =
  '/api/web/v1/users/renterContact/getTenantsRequestedToUsePayment';

/**
 * Get if tenants have requested to use payment
 */
export const RentalManagerRenterContactWebApiHandler_getTenantsRequestedToUsePayment = (
  getParams: GetTenantsRequestedToUsePaymentParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetTenantsRequestedToUsePaymentParams, never, boolean>({
    getParams: getParams,
    endpoint: RentalManagerRenterContactWebApiHandler_getTenantsRequestedToUsePayment_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
